module.exports = __webpack_public_path__ + "static/media/grass.da8bbb8e.svg";